import { get, post } from "./index";

// 定义接口参数类型
interface VisitorParams {
  sessionId?: string;
  [key: string]: any;
}

// 其他接口相关API
export const otherApi = {
  // 访客会话
  visitorSession(params?: VisitorParams) {
    return get(`/visitor/session`, params);
  },

  // 访客PV统计
  visitorPv(sessionId: string) {
    return post(`/visitor/pv?sessionId=${sessionId}`);
  },

  // 访客Ping
  visitorPing(sessionId: string) {
    return post(`/visitor/ping?sessionId=${sessionId}`);
  },

  // X社交链接
  getXUrl(params?: VisitorParams) {
    return get(`/misc/x/url`, params);
  },

  // Telegram链接
  getTgUrl(params?: VisitorParams) {
    return get(`/misc/telegram/url`, params);
  },

  // Instagram链接
  getInsUrl(params?: VisitorParams) {
    return get(`/misc/ins/url`, params);
  },

  // Discord链接
  getDisUrl(params?: VisitorParams) {
    return get(`/misc/discard/url`, params);
  },

  // FAQ链接
  getFaqUrl(params?: VisitorParams) {
    return get(`/misc/faq/url`, params);
  },
};

// 导出单独的函数以保持向后兼容
export const visitorSessionApi = (params?: VisitorParams) =>
  otherApi.visitorSession(params);
export const visitorPvApi = (sessionId: string) =>
  otherApi.visitorPv(sessionId);
export const visitorPingApi = (sessionId: string) =>
  otherApi.visitorPing(sessionId);
export const xUrlApi = (params?: VisitorParams) => otherApi.getXUrl(params);
export const tgUrlApi = (params?: VisitorParams) => otherApi.getTgUrl(params);
export const insUrlApi = (params?: VisitorParams) => otherApi.getInsUrl(params);
export const disUrlApi = (params?: VisitorParams) => otherApi.getDisUrl(params);
export const faqUrlApi = (params?: VisitorParams) => otherApi.getFaqUrl(params);
